import { motion } from "framer-motion";
import { Users, FileSignature, Search, TrendingUp, Trophy, Globe } from "lucide-react";
import { useLang } from "@/i18n";

const SPANS = ["md:col-span-7", "md:col-span-5", "md:col-span-5", "md:col-span-7", "md:col-span-6", "md:col-span-6"];
const ICONS = [Users, FileSignature, Search, TrendingUp, Trophy, Globe];

export default function Services() {
  const { t } = useLang();
  const services = ICONS.map((icon, i) => ({
    icon,
    title: t(`services.${i + 1}.t`),
    text: t(`services.${i + 1}.x`),
    span: SPANS[i],
  }));
  const handleServiceClick = (title) => {
    window.dispatchEvent(new CustomEvent("prefill-sujet", { detail: `Demande : ${title}` }));
    document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="services" data-testid="services-section" className="py-28 lg:py-40 bg-[#121214]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="mb-20"
        >
          <p className="text-[#C5A059] text-xs uppercase tracking-[0.4em] mb-6">{t("services.eyebrow")}</p>
          <h2 className="font-display text-4xl md:text-5xl uppercase font-bold tracking-tight max-w-2xl leading-tight">
            {t("services.title")}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {services.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 2) * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className={`${s.span} group bg-[#18181B] border border-[#27272A] p-10 lg:p-12 hover:border-[#C5A059]/50 transition-colors duration-500 cursor-pointer`}
              data-testid={`service-card-${i}`}
              onClick={() => handleServiceClick(s.title)}
              role="link"
              aria-label={`${t("nav.contact")} — ${s.title}`}
            >
              <s.icon size={28} className="text-[#C5A059]" strokeWidth={1.5} />
              <h3 className="font-display text-2xl md:text-3xl uppercase font-medium mt-8">
                {s.title}
              </h3>
              <p className="text-base leading-relaxed text-[#A1A1AA] mt-4 max-w-lg">{s.text}</p>
              <div className="h-px w-0 group-hover:w-full bg-[#C5A059] mt-8 transition-[width] duration-700" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
